import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileItem } from '../../../models/fileItem';

@Component({ standalone:false,
  selector: 'app-show-file-dialog',
  templateUrl: 'show-file-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['show-file-dialog.component.scss']
})
export class ShowFileDialogComponent {
  public title:string= "Title";
  public cancelButtonText:string = "Close";

  public fileItemArray?:FileItem[];

  private fileChanged:boolean=false;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<ShowFileDialogComponent>) {
    if(data){
        this.title=data.title;
        this.fileItemArray = data.fileItemArray;
    }
  }

  public onCancelClick(){
    this.dialogRef.close(this.fileChanged);
  }

  public onFileChanged(){
    this.fileChanged=true;
  }
}